import type { DividerProps } from '@time-line/components/common';
import { AccordionItem } from '@time-line/components/common';
import type { ReactNode } from 'react';
import type { SanityProduct } from 'types/cms/SanityProduct';

import { BundleAccordionItemPanel } from './BundleAccordionItemPanel';

interface BundleAccordionItemProps {
  product?: SanityProduct;
  dividerProps?: DividerProps;
  header: ReactNode;
  isLast?: boolean;
}

export function BundleAccordionItem({
  product,
  dividerProps,
  header,
  isLast = false,
}: BundleAccordionItemProps) {
  return (
    <AccordionItem
      header={header}
      iconVariant="caret"
      isDisabled={!product}
      dividerProps={dividerProps}
      isLast={isLast}
    >
      {product && <BundleAccordionItemPanel product={product} />}
    </AccordionItem>
  );
}
